import * as R from "ramda";

// Get visible checks
export default (checks, { text, groups }) => {
  if (checks !== null) {
    let groupedMonitors = checks;
    if (!R.isEmpty(groups)) {
      groupedMonitors = R.filter(
        el => R.any(g => groups.includes(g), el.labels),
        groupedMonitors
      );
    }

    return groupedMonitors.filter(checks => {
      let textMatch;
      if (checks.protocol_type === "HTTP(S)") {
        if (
          checks.alias !== null &&
          checks.alias.toLowerCase().includes(text.toLowerCase())
        ) {
          textMatch = text;
          return true;
        }
        textMatch = text
          ? checks.url.toLowerCase().includes(text.toLowerCase())
          : true;
      } else {
        if (
          checks.alias !== null &&
          checks.alias.toLowerCase().includes(text.toLowerCase())
        ) {
          textMatch = text;
          return true;
        }
        textMatch = text
          ? checks.host.toLowerCase().includes(text.toLowerCase())
          : true;
      }
      return textMatch;
    });
  } else {
    return [];
  }
};
